<template>
  <div class="container">
    <a-form :model="handleList" class="search-form" @submit="handleList">
      <a-form-item name="content">
        <div class="form-item-content">
          <div class="label">搜索内容：</div>
          <a-input
            placeholder="姓名/电话"
            v-model:value="listRequest.content"
          />
        </div>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" html-type="submit">搜索</a-button>
        <a-button
          type="primary"
          @click="openAdd = true"
          style="margin-bottom: 16px"
        >
          添加用户地址
        </a-button>
      </a-form-item>
    </a-form>
    <a-table
      :columns="columns"
      :data-source="addressList"
      :pagination="{
        current: listRequest.current,
        pageSize: listRequest.size,
        total: total,
        showSizeChanger: true,
        pageSizeOptions: [10, 20, 30, 40, 50],
        onChange: handleChange,
        onShowSizeChange: handleSizeChange,
      }"
      bordered
    >
      <template
        #bodyCell="{ column, record }: { column: ColumnType, record: Address }"
      >
        <template v-if="column.dataIndex === 'is_delete'">
          <a-tag v-if="record.is_delete === 1" color="green">正常</a-tag>
          <a-tag v-if="record.is_delete === 2" color="red">回收站</a-tag>
        </template>
        <template v-else-if="column.dataIndex === 'is_default'">
          <span v-if="record.is_default === 1">非默认</span>
          <span v-else>默认</span>
        </template>
        <template v-else-if="column.dataIndex === 'category'">
          <span v-if="record.is_default === 1">寄件地址</span>
          <span v-else>收件地址</span>
        </template>
        <template v-else-if="column.dataIndex === 'create_at'">
          <span
            >{{ dayjs(record.create_at).format("YYYY-MM-DD HH:mm:ss") }}
          </span>
        </template>
        <template v-else-if="column.dataIndex === 'operator'">
          <a-button
            @click="handleUpdate(record)"
            type="primary"
            :style="{ marginRight: '8px' }"
            >编辑
          </a-button>
          <a-button
            @click="submitDelete(record)"
            type="primary"
            :style="{
              backgroundColor: '#ff7a45',
              color: 'white',
              marginRight: '8px',
            }"
            >删除
          </a-button>
          <a-button
            @click="submitDrop(record)"
            type="primary"
            :style="{
              backgroundColor: '#ff4d4f',
              color: 'white',
            }"
            >彻底删除
          </a-button>
        </template>
      </template>
    </a-table>
    <a-modal
      v-model:open="openAdd"
      title="添加用户地址数据"
      @ok="submitAdd"
      cancelText="取消"
    >
      <a-form :model="addRequest">
        <a-form-item label="会员">
          <a-select v-model:value="addRequest.user_id">
            <a-select-option
              v-for="user in userList"
              :value="user.id"
              :key="user.id"
              >{{ user.id }} - {{ user.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="收/寄件人名称：">
          <a-input v-model:value="addRequest.name" />
        </a-form-item>
        <a-form-item label="电话：">
          <a-input v-model:value="addRequest.phone" />
        </a-form-item>
        <a-form-item label="省份：">
          <a-input v-model:value="addRequest.province" />
        </a-form-item>
        <a-form-item label="城市：">
          <a-input v-model:value="addRequest.city" />
        </a-form-item>
        <a-form-item label="县区：">
          <a-input v-model:value="addRequest.district" />
        </a-form-item>
        <a-form-item label="详细地址：">
          <a-textarea v-model:value="addRequest.address" />
        </a-form-item>
        <a-form-item label="邮政编码：">
          <a-input v-model:value="addRequest.postcode" />
        </a-form-item>
        <a-form-item label="类别：">
          <a-select v-model:value="addRequest.category">
            <a-select-option :value="1">寄件地址</a-select-option>
            <a-select-option :value="2">收件地址</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="是否默认：">
          <a-radio-group v-model:value="addRequest.is_default">
            <a-radio :value="1">非默认</a-radio>
            <a-radio :value="2">默认</a-radio>
          </a-radio-group>
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal
      v-model:open="openUpdate"
      title="修改快递数据"
      @ok="submitUpdate"
      cancelText="取消"
    >
      <a-form :model="updateRequest" style="margin-top: 20px">
        <a-form-item label="收/寄件人名称：">
          <a-input v-model:value="updateRequest.name" />
        </a-form-item>
        <a-form-item label="电话：">
          <a-input v-model:value="updateRequest.phone" />
        </a-form-item>
        <a-form-item label="省份：">
          <a-input v-model:value="updateRequest.province" />
        </a-form-item>
        <a-form-item label="城市：">
          <a-input v-model:value="updateRequest.city" />
        </a-form-item>
        <a-form-item label="县区：">
          <a-input v-model:value="updateRequest.district" />
        </a-form-item>
        <a-form-item label="详细地址：">
          <a-textarea v-model:value="updateRequest.address" />
        </a-form-item>
        <a-form-item label="邮政编码：">
          <a-input v-model:value="updateRequest.postcode" />
        </a-form-item>
        <a-form-item label="类别：">
          <a-select v-model:value="updateRequest.category">
            <a-select-option :value="1">寄件地址</a-select-option>
            <a-select-option :value="2">收件地址</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="是否默认：">
          <a-radio-group v-model:value="addRequest.is_default">
            <a-radio :value="1">非默认</a-radio>
            <a-radio :value="2">默认</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="状态">
          <a-select v-model:value="updateRequest.is_delete">
            <a-select-option :value="1">正常</a-select-option>
            <a-select-option :value="2">回收站</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script setup lang="ts">
import { onMounted, reactive, ref, watch } from "vue";
import { AddressService } from "@/api/services/AddressService";
import { message } from "ant-design-vue";
import dayjs from "dayjs";
import { ColumnType } from "ant-design-vue/lib/table";
import { Address } from "@/api/models/address/Address";
import { AddressAddRequest } from "@/api/models/address/AddressAddRequest";
import { AddressUpdateRequest } from "@/api/models/address/AddressUpdateRequest";
import { AddressListRequest } from "@/api/models/address/AddressListRequest";
import { UserService } from "@/api/services/UserService";
import { User } from "@/api/models/user/User";
import { PostalService } from "@/api/services/PostalService";

const total = ref<number>(0);

const listRequest = reactive<AddressListRequest>({
  current: 1,
  size: 20,
  content: "",
});

const addressList = ref<Address[]>([]);

const handleList = async () => {
  const res = await AddressService.ListAll(listRequest);
  if (res.code === 0) {
    addressList.value = res.data.records;
    total.value = res.data.total;
  } else {
    message.error(res.msg);
  }
};

const userList = ref<User[]>([]);

const handleUserList = async () => {
  const res = await UserService.ListAll({ current: 0, size: 0 });
  if (res.code === 0) {
    userList.value = res.data.records;
  } else {
    message.error(res.msg);
  }
};

onMounted(async () => {
  await handleList();
  await handleUserList();
});

const handleSizeChange = (current: number, pageSize: number) => {
  listRequest.current = current;
  listRequest.size = pageSize;
  handleList();
};

const handleChange = (page: number, pageSize: number) => {
  listRequest.current = page;
  listRequest.size = pageSize;
  handleList();
};

const addRequest = reactive<AddressAddRequest>({
  name: "",
  phone: "",
  address: "",
  postcode: "",
  category: 1,
  province: "",
  city: "",
  district: "",
  is_default: 1,
});

const handleGetPostalCodeAdd = async () => {
  const res = await PostalService.Get({
    province: addRequest.province,
    city: addRequest.city,
    district: addRequest.district,
  });
  if (res.code === 0) {
    addRequest.postcode = res.data.postcode;
  } else {
    message.error(res.msg);
  }
};

watch(
  () => [addRequest.province, addRequest.city, addRequest.district],
  ([newProvince, newCity, newDistrict]) => {
    if (newProvince && newCity && newDistrict) {
      handleGetPostalCodeAdd();
    }
  }
);

const openAdd = ref(false);

const submitAdd = async () => {
  const res = await AddressService.Add(addRequest);
  if (res.code === 0) {
    message.success("添加成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const openUpdate = ref(false);

const updateRequest = reactive<AddressUpdateRequest>({
  id: 0,
  is_delete: 0,
  user_id: 0,
  name: "",
  phone: "",
  address: "",
  postcode: "",
  category: 0,
  province: "",
  city: "",
  district: "",
  is_default: 0,
});

const handleGetPostalCodeUpdate = async () => {
  const res = await PostalService.Get({
    province: updateRequest.province,
    city: updateRequest.city,
    district: updateRequest.district,
  });
  if (res.code === 0) {
    updateRequest.postcode = res.data.postcode;
  } else {
    message.error(res.msg);
  }
};

watch(
  () => [updateRequest.province, updateRequest.city, updateRequest.district],
  ([newProvince, newCity, newDistrict]) => {
    if (newProvince && newCity && newDistrict) {
      handleGetPostalCodeUpdate();
    }
  }
);

const handleUpdate = (record: Address) => {
  openUpdate.value = true;
  Object.assign(updateRequest, record);
};

const submitUpdate = async () => {
  const res = await AddressService.Update(updateRequest);
  if (res.code === 0) {
    message.success("修改成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const submitDelete = async (record: Address) => {
  const res = await AddressService.Delete(record.id);
  if (res.code === 0) {
    message.success("删除成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const submitDrop = async (record: Address) => {
  const res = await AddressService.Drop(record.id);
  if (res.code === 0) {
    message.success("删除成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const columns: ColumnType[] = [
  {
    title: "Id",
    dataIndex: "id",
    align: "center",
  },
  {
    title: "用户id",
    dataIndex: "user_id",
    align: "center",
  },
  {
    title: "收/寄件人名称",
    dataIndex: "name",
    align: "center",
  },
  {
    title: "电话号码",
    dataIndex: "phone",
    align: "center",
  },
  {
    title: "省份",
    dataIndex: "province",
    align: "center",
  },
  {
    title: "城市",
    dataIndex: "city",
    align: "center",
  },
  {
    title: "县区",
    dataIndex: "district",
    align: "center",
  },
  {
    title: "地址信息",
    dataIndex: "address",
    align: "center",
  },
  {
    title: "邮政编码",
    dataIndex: "postcode",
    align: "center",
  },
  {
    title: "是否为默认",
    dataIndex: "is_default",
    align: "center",
  },
  {
    title: "地址类型",
    dataIndex: "category",
    align: "center",
  },
  {
    title: "状态",
    dataIndex: "is_delete",
    align: "center",
  },
  {
    title: "创建时间",
    dataIndex: "create_at",
    align: "center",
  },
  {
    title: "操作",
    dataIndex: "operator",
    align: "center",
  },
];
</script>

<style scoped>
.container {
  border: 1px solid #d9d9d9;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  width: 98%;
  margin-left: 1%;
  background-color: white;
  margin-top: 16px;
}
</style>
